<template>
  <el-dialog
    :title="clusterDialog.type === 'edit' ? '编辑超边' : '新增超边'"
    :visible.sync="clusterDialog.visible"
    width="600px"
    @close="clusterDialogClose"
  >
    <el-form :model="clusterDialog.form" label-width="120px" :rules="clusterRules" ref="clusterFormRef">
      <el-form-item label="超边名称" prop="name">
        <el-input v-model="clusterDialog.form.name" />
      </el-form-item>
      <el-form-item label="超边类型" prop="hyperedgeType">
        <el-select v-model="clusterDialog.form.hyperedgeType" placeholder="请选择" clearable>
          <el-option
            v-for="(item, index) in clusterTypeList"
            :key="index"
            :label="item.text"
            :value="index"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="clusterDialogClose">取消</el-button>
      <el-button type="primary" @click="clusterSubmit">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { hyperedgeSave } from '@/request/api/knowledge_graph.js'

export default {
  name: 'KgClusterDialog',
  inject: ['clusterDialog', 'clusterTypeList', 'getknowledgeData', 'courseId'],
  data() {
    return {
      clusterRules: {
        name: [{ required: true, message: '请输入超边名称', trigger: 'blur' }],
        hyperedgeType: [{ required: true, message: '请选择超边类型', trigger: 'change' }],
      },
    }
  },
  methods: {
    clusterDialogClose() {
      this.clusterDialog.visible = false
      this.clusterDialog.type = 'add'
      this.clusterDialog.form = { quoteId: '', name: '', hyperedgeType: 0 }
    },
    clusterSubmit() {
      this.$refs.clusterFormRef.validate(valid => {
        if (valid) {
          var form = this.clusterDialog.form
          var params = {
            id: form.id,
            name: form.name,
            hyperedgeType: form.hyperedgeType,
            courseId: this.courseId.value,
          }
          hyperedgeSave(params).then(res => {
            if (res.code != 0) return this.$message.error(res.msg || '操作失败')
            this.$message.success('操作成功')
            this.clusterDialogClose()
            this.getknowledgeData()
          })
        }
      })
    },
  },
}
</script>
